/**
 * @file shipping-constants.ts
 *
 * Immutable shipping vocabulary ported from the design-reviewed Website Builder
 * v2: the shipping-method ids, the "all regions" sentinel location, and the
 * free-shipping requirement options (with which ones need a minimum order
 * amount). Kept separate from the value factories in `shipping-defaults.ts` so
 * the constants can be shared by the helpers, the overview, and the forms without
 * pulling in the shop-settings defaults.
 */

import type { ShippingZoneLocation } from '../api/shop-types';

/** The supported shipping-method ids. */
export const FLAT_RATE = 'flat_rate';
export const FREE_SHIPPING = 'free_shipping';

/** Location `type`/`code` sentinel meaning the zone ships everywhere. */
export const ALL_REGIONS = 'all_regions';

/** The synthetic "all regions" location (selectable only on its own). */
export const ALL_REGIONS_LOCATION: ShippingZoneLocation = {
  code: ALL_REGIONS,
  type: ALL_REGIONS,
};

/** A free-shipping requirement option and whether it needs a minimum amount. */
export interface ShippingRequirementOption {
  value: string;
  requiresMinimumAmount: boolean;
}

/**
 * The free-shipping `requires` options, in display order. `requiresMinimumAmount`
 * drives whether the minimum-amount field is shown for a chosen option.
 */
export const SHIPPING_REQUIREMENT_OPTIONS: ShippingRequirementOption[] = [
  { value: '', requiresMinimumAmount: false },
  { value: 'coupon', requiresMinimumAmount: false },
  { value: 'min_amount', requiresMinimumAmount: true },
  { value: 'either', requiresMinimumAmount: true },
  { value: 'both', requiresMinimumAmount: true },
];
